<template>
    <div class="role-wrapper">
        <router-view></router-view>
        <div class="role-container" v-if="isRouter">
            <div class="content-wrapper card-wrapper">
                <commonSearch :custom="custom" @reset="clickResetBtn" @commonSearch-Click="searClick"></commonSearch>
                <div class="content-top clearfix" v-permission="taskListAdd">
                    <router-link class="add-btn" :to="{ name: 'taskAdd' }">{{ $t('common.create') }}
                    </router-link>
                </div>
                <TaskTable :tableData="tableData" :pageSize="pageSize" :pageNo="pageIndex" @reloadData="searClick">
                </TaskTable>
                <my-pagination :pageSize="pageSize" :pageIndex="pageIndex" :total="totalRows"
                    @currentChange="handleCurrentChange" @sizeChange="handleSizeChange"></my-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import CommonSearch from "@/base/searchCommon.vue";
import TaskTable from "./components/taskTable.vue";
import MyPagination from "@/base/my-pagination/my-pagination.vue";
import Cookies from "js-cookie";
export default {
    components: {
        CommonSearch,
        TaskTable,
        MyPagination,
    },
    data() {
        return {
            isRouter: false,
            pageSize: 10,
            pageIndex: 1,
            totalRows: 0,
            custom: [
                {
                    name: vm.$t('operation.task.patrolServer') + "：",
                    activeCode: null,
                    type: "multipleSelect",
                    collapseTags: true,
                    item: [],
                },
                {
                    name: vm.$t('operation.task.status') + "：",
                    activeCode: null,
                    type: "select",
                    item: [{ value: null, label: vm.$t('common.all') }, { value: 0, label: vm.$t('distributor.inactive') }, { value: 1, label: vm.$t('distributor.active') }]
                },
                {
                    name: vm.$t('operation.task.taskName') + "：",
                    activeCode: null,
                    type: "input",
                    item: [],
                }
            ],
            monitorId: Number(Cookies.get("monitorId")),
            tableData: [],
        }
    },
    created() {
    },
    mounted() {
        this._getDataList();
        this.getServerDataList();
    },
    methods: {
        async getServerDataList() {
            let res = await this.$Http.get(`${this.$Api.accountRoleList}/${this.monitorId}/2`)
            if (res.success && res.result.length > 0) {
                let list = [];
                res.result.forEach(item => {
                    list.push({ value: item.userId, label: item.userName });
                })
                this.custom[0].item = list;
            }
        },

        searClick(params) {
            this.pageIndex = 1;
            this._getDataList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this._getDataList();
        },
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
            this._getDataList();
        },
        clickResetBtn() {
            this.pageIndex = 1;
            this._getDataList();
        },
        _getDataList() {
            let params = {
                index: this.pageIndex,
                pageSize: this.pageSize,
                serverIdList: this.custom[0].activeCode,
                taskName: this.custom[2].activeCode==''? null: this.custom[2].activeCode,
                status: this.custom[1].activeCode,
            };
            this.$Http.post(this.$Api.captureTaskGetCaptureTaskList + '/' + this.monitorId, params).then(res => {
                if (res.success) {
                    this.tableData = res.result.pageData;
                    this.totalRows = res.result.totalRows;
                }
            });
        },
    },
    watch: {
        $route(to, from) {
            if (to.name === "taskList") {
                this.isRouter = true;
                this._getDataList();
                this.getServerDataList();
            } else {
                this.isRouter = false;
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "taskList") {
                vm.isRouter = true;
            } else {
                vm.isRouter = false;
            }
        });
    }
}
</script>

<style scoped lang="scss">
@import "@/common/scss/button";
@import "@/common/scss/pagination";

.content-wrapper {
    position: relative;

    .content-top {
        margin-bottom: 16px;
        box-sizing: border-box;

        .btn {
            float: left;
        }
    }
}
</style>